import React from 'react';
import PropTypes from 'prop-types';
import { SearchIcon } from '../../../../assets/icons';

const ModalOperatorsSearch = ({ title, searchText, onSearch }) => {
  return (
    <div className='modal__container__body__searchbox flex flex-jc-sb flex-ai-c'>
      <input
        value={searchText}
        onChange={(event) => onSearch(event.target.value)}
        className='modal__container__body__searchbox__input'
        type='text'
        placeholder={title}
      />
      <div className='modal__container__body__searchbox__icon grid grid-pi-c'>
        <img className='' src={SearchIcon} alt='' />
      </div>
    </div>
  );
};

ModalOperatorsSearch.propTypes = {
  title: PropTypes.string.isRequired,
  searchText: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
};

export default ModalOperatorsSearch;
